"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appActivateAction = exports.APP_ACTIVATE = void 0;

var _reduxUtils = require("@dealersocket/redux-utils");

var _lifecycle = require("../lifecycle.reducer");

var postfix = "/".concat(_lifecycle.lifecycleReducer.sliceName, "/app");
var APP_ACTIVATE = "APP_ACTIVATE".concat(postfix);
exports.APP_ACTIVATE = APP_ACTIVATE;
var appActivateAction = (0, _reduxUtils.createAction)(APP_ACTIVATE);
exports.appActivateAction = appActivateAction;